import { render, staticRenderFns } from "./CategorySummary.vue?vue&type=template&id=284eb43a"
import script from "./CategorySummary.vue?vue&type=script&lang=js"
export * from "./CategorySummary.vue?vue&type=script&lang=js"
import style0 from "./CategorySummary.vue?vue&type=style&index=0&id=284eb43a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports